"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISPATCH = exports.ACTION = void 0;
var ACTION = 'action';
exports.ACTION = ACTION;
var DISPATCH = 'dispatch';
exports.DISPATCH = DISPATCH;